import React from 'react';
import Select from "./Select";
import SelectItem from "./SelectItem";
import SelectTrigger from "./SelectTrigger";
import SelectContent from "./SelectContent";
import SelectValue from "./SelectValue";
import { useTranslation } from 'react-i18next';

const DateSelect = ({ value = "Today", onChange }) => {
  const { t } = useTranslation();
  
  const dateOptions = [
    { value: "Yesterday", translationKey: "form.schedule.yesterday" },
    { value: "Today", translationKey: "form.schedule.today" },
    { value: "Tomorrow", translationKey: "form.schedule.tomorrow" }
  ];
  
  const getCurrentTranslation = () => {
    const option = dateOptions.find(opt => opt.value === value);
    return option ? t(option.translationKey) : value;
  };

  return (
    <Select 
      value={value} 
      onValueChange={(newValue) => {
        if (onChange) onChange(newValue);
      }}
    >
      <SelectTrigger className="w-">
        <SelectValue>{getCurrentTranslation()}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {dateOptions.map(option => (
          <SelectItem key={option.value} value={option.value}>
            {t(option.translationKey)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default DateSelect;